var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointeur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235.4 367.4",
    style: {
      enableBackground: "new 0 0 235.4 367.4"
    },
    xmlSpace: "preserve",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#092155;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,6C56.6,10.6,10,57,4.9,106.2c-2,19.4,1.1,38,7.9,54.5h0l0.1,0.2c2.1,5,4.5,9.8,7.3,14.5L107.8,350 c6.2,12.3,16.1,12.2,22-0.2l84.6-176.5c9.3-16.4,14.7-35.3,14.7-55.5C229.1,52.2,172.8-0.3,105.8,6z M127.5,176.5 c-42.7,7.2-79.3-29.4-72.1-72.1c3.9-23.4,27.6-46.8,51-50.6c42.4-6.8,78.5,29.3,71.7,71.7C174.3,148.9,150.8,172.6,127.5,176.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointeur);
export default __webpack_public_path__ + "static/media/pointeur.2aee0076db9a77b5f7415cea8dd7a5a0.svg";
export { ForwardRef as ReactComponent };